import jwtDecode from 'jwt-decode'

import { TITLE } from 'Global/constants'

const TOKEN_KEY = `${TITLE.toLowerCase()}_token`
const USER_KEY = `${TITLE.toLowerCase()}_user`

/**
 * Deletes the token from local storage.
 */
export const deleteToken = () => {
  return localStorage.removeItem(TOKEN_KEY)
}

/**
 * Deletes the user object from local storage.
 */
export const deleteUser = () => {
  return localStorage.removeItem(USER_KEY)
}

/**
 * Retrieves the token from local storage.
 * @returns {string|null} Token string or null if none is found.
 */
export const getToken = () => {
  return localStorage.getItem(TOKEN_KEY)
}

/**
 * Retrieves the user object from local storage.
 * @returns {object|null} User object or null if none is found.
 */
export const getUser = () => {
  return JSON.parse(localStorage.getItem(USER_KEY))
}

/**
 * Checks whether the user has a token & user profile saved.
 * @returns {Object|null} User object or null if no token was found
 * or token is about to expire (in the next hour).
 */
export const getTokenFromLocalStorage = () => {
  const token = getToken()
  const user = getUser()

  if (token && user) {
    const jwt = jwtDecode(token)
    if (jwt.exp < Math.floor(Date.now() / 1000) - 3600) {
      deleteToken()
      deleteUser()

      return null
    }

    return {
      ...user,
      token,
    }
  } else {
    return null
  }
}

/**
 * Saves the token to local storage.
 * @param {string} token
 */
export const saveToken = token => {
  localStorage.setItem(TOKEN_KEY, token)
}

/**
 * Saves the stringified user object to local storage.
 * @param {Object} user
 */
export const saveUser = user => {
  localStorage.setItem(USER_KEY, JSON.stringify(user))
}
